
import PartnerOrganizations from 'shared_src/dictionaries/partnerOrganizations'

const encounterTypesNameMapping = {
  home: 'Home',
  phone: 'Telephonic'
}

const Section3 = ({
  primaryInsuranceProvider,
  pcpFullname,
  lastEncounter,
  lastEncounterType,
  lastEncounterTimeAgo,
  partnerOrganization
}) => {
  const RenderLastEncounterInfo = () =>
    <span key={`${lastEncounterType}-span`}>{encounterTypesNameMapping[lastEncounterType]} {lastEncounterTimeAgo}</span>

  return (
    <div className='section-3'>
      <div
        className='primary-insurance'
        title='Primary Insurance'
      >
        {primaryInsuranceProvider ? <span>{primaryInsuranceProvider}</span> : 'No Primary Insurance'}
      </div>
      <div
        className='primary-care-physician'
        title='Primary Care Physician'
      >
        {pcpFullname || 'No Primary Care Physician'}
      </div>
      <div
        className='partner-organization'
        title='Managing Organization'
      >
          {(PartnerOrganizations.find(o => o.value === partnerOrganization)?.label ?? partnerOrganization)
              || 'None'}
      </div>
      <div
        className='last-encounter'
        title='Last Encounter'
      >
        <span className='label' />
        {lastEncounter ? <RenderLastEncounterInfo /> : 'No encounters yet'}
      </div>
    </div>
  )
}

export default Section3
